import React from 'react'
import styles from './styles.module.sass'

export const PreloaderIcon = ({ stroke = 'white' }) => (
  <svg className={styles.preloader} width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke={stroke} d="M25 14C25 16.1756 24.3549 18.3023 23.1462 20.1113C21.9375 21.9202 20.2195 23.3301 18.2095 24.1627C16.1995 24.9952 13.9878 25.2131 11.854 24.7886C9.72022 24.3642 7.76021 23.3165 6.22183 21.7782C4.68345 20.2398 3.6358 18.2798 3.21137 16.146C2.78693 14.0122 3.00477 11.8005 3.83733 9.79048C4.66989 7.78049 6.07979 6.06253 7.88873 4.85383C9.69767 3.64514 11.8244 3 14 3" strokeWidth="6" strokeLinecap="round" />
  </svg>
)
